// extracted by mini-css-extract-plugin
export default {"text":"text-30wJj","container":"container-1QTQh"};